
export const  getSuncoCustomFields = ({
      intent,
      use_custom_fields,
      integrations,
      i,
      updateIntent,
      getCustomFields,
    }) => {
    const integration_zendesk_full = integrations?.filter(
      (int) => int.channel === "zendesk_full"
    )[0];

    var use_custom = integration_zendesk_full?.multiple.filter(
      (int) => int.use_custom_fields
    );

    if (use_custom?.length === 1) {
      var new_desk_id = use_custom[0].id;
      if (intent.extensions?.variables_desk) {
        if (
          intent.extensions.variables_desk[i] &&
          intent.extensions.variables_desk[i].zendesk_ticket_field
        ) {
          intent.extensions.variables_desk[i].zendesk_ticket_field.desk_id =
            new_desk_id;
        }
      }
      updateIntent(intent);
      if (!use_custom_fields || !use_custom_fields[new_desk_id]) {
        getCustomFields("zendesk", new_desk_id, intent );
      }
    }

    const integration_sunco = integrationSunco({ integrations });
    if (integration_sunco?.info?.zendesk?.use_custom_fields?.active) {
      const desk_id = integration_sunco.channel_id;
      if (!use_custom_fields || !use_custom_fields[desk_id]) {
        getCustomFields("sunco", desk_id, intent );
      }
    }
  };

  function integrationSunco({ integrations }) {
    if (!integrations) {
      return null;
    }
    return integrations?.find((int) => int.channel === "sunco");
  }

